import { isSpectraData1D } from './isSpectraData1D';
export function formatData(input = []) {
    let inputClone = JSON.parse(JSON.stringify(input));
    let spectra = [];
    for (const spectraData of inputClone) {
        const { info } = spectraData;
        if (isSpectraData1D(spectraData)) {
            spectra.push({ info, ranges: { values: spectraData.ranges } });
        }
        else {
            spectra.push({ info, zones: { values: spectraData.zones } });
        }
    }
    return spectra;
}
//# sourceMappingURL=formatData.js.map